define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isProduction = exports.isTest = exports.isDevelopment = exports.isLocal = exports.getEnvironment = exports.getVersion = void 0;
    function getVersion() {
        return process.env.VERSION;
    }
    exports.getVersion = getVersion;
    function getEnvironment() {
        return (process.env.ENV || "").toLowerCase();
    }
    exports.getEnvironment = getEnvironment;
    function isLocal() {
        return getEnvironment() == "local";
    }
    exports.isLocal = isLocal;
    function isDevelopment() {
        return getEnvironment() == "development";
    }
    exports.isDevelopment = isDevelopment;
    function isTest() {
        return getEnvironment() == "test";
    }
    exports.isTest = isTest;
    function isProduction() {
        return getEnvironment() == "production";
    }
    exports.isProduction = isProduction;
});
